import { render, staticRenderFns } from "./DelEdit.vue?vue&type=template&id=fa6d4004"
import script from "./DelEdit.vue?vue&type=script&lang=js"
export * from "./DelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports